(function () {
    'use strict';

    function initSlider(root) {
        var viewport = root.querySelector('[data-slider-viewport]');
        var track = root.querySelector('[data-slider-track]');
        var prev = root.querySelector('[data-action="prev"]');
        var next = root.querySelector('[data-action="next"]');
        if (!viewport || !track) return;

        var isRTL = getComputedStyle(viewport).direction === 'rtl';
        var dirSign = isRTL ? -1 : 1;

        function maxScrollLeft() {
            return track.scrollWidth - viewport.clientWidth;
        }

        function currentScroll() {
            // Normalize RTL scrollLeft (which can be negative or inverted depending on browser) to a 0..max range.
            var sl = viewport.scrollLeft;
            return isRTL ? Math.abs(sl) : sl;
        }

        function updateArrows() {
            if (!prev || !next) return;
            var max = maxScrollLeft();
            var canScroll = max > 2;
            var atStart = currentScroll() <= 2;
            var atEnd = currentScroll() >= max - 2;
            prev.hidden = !canScroll || atStart;
            next.hidden = !canScroll || atEnd;
        }

        var resizeTimer;
        window.addEventListener('resize', function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(updateArrows, 150);
        });
        viewport.addEventListener('scroll', updateArrows, { passive: true });
        updateArrows();

        if (prev) {
            prev.addEventListener('click', function () {
                viewport.scrollBy({ left: -dirSign * viewport.clientWidth * 0.6, behavior: 'smooth' });
            });
        }
        if (next) {
            next.addEventListener('click', function () {
                viewport.scrollBy({ left: dirSign * viewport.clientWidth * 0.6, behavior: 'smooth' });
            });
        }

        // Pointer-based drag-to-scroll with click suppression so a drag doesn't also trigger card navigation.
        var isDown = false;
        var startX = 0;
        var startScrollLeft = 0;
        var totalMove = 0;
        var DRAG_THRESHOLD = 6;

        viewport.addEventListener('pointerdown', function (e) {
            if (e.pointerType === 'mouse' && e.button !== 0) return;
            isDown = true;
            totalMove = 0;
            startX = e.clientX;
            startScrollLeft = viewport.scrollLeft;
            //viewport.classList.add('is-dragging');
            //viewport.setPointerCapture(e.pointerId);
        });

        viewport.addEventListener('pointermove', function (e) {
            if (!isDown) return;
            var delta = e.clientX - startX;
            totalMove = Math.max(totalMove, Math.abs(delta));
            if (totalMove > DRAG_THRESHOLD) {
                e.preventDefault();
                if (!viewport.classList.contains('is-dragging')) {
                    viewport.classList.add('is-dragging');
                    viewport.setPointerCapture(e.pointerId);
                }
            }
            viewport.scrollLeft = startScrollLeft - delta;
        });
        
        // viewport.addEventListener('pointermove', function (e) {
        //     if (!isDown) return;
        //     var delta = e.clientX - startX;
        //     totalMove = Math.max(totalMove, Math.abs(delta));
        //     if (totalMove > DRAG_THRESHOLD) e.preventDefault();
        //     viewport.scrollLeft = startScrollLeft - delta;
        // });

        function endDrag() {
            if (!isDown) return;
            isDown = false;
            totalMove = 0;
            viewport.classList.remove('is-dragging');
        }
        viewport.addEventListener('pointerup', endDrag);
        viewport.addEventListener('pointercancel', endDrag);
        viewport.addEventListener('pointerleave', endDrag);

        // If the pointer moved past the threshold, swallow the click that follows so cards don't navigate while swiping.
        viewport.addEventListener('click', function (e) {
            if (totalMove > DRAG_THRESHOLD) {
                e.preventDefault();
                e.stopPropagation();
            }
        }, true);

        // Keyboard accessibility: arrow keys move the slider when it (or a card inside it) has focus.
        viewport.addEventListener('keydown', function (e) {
            if (e.key === 'ArrowLeft') {
                e.preventDefault();
                viewport.scrollBy({ left: isRTL ? 150 : -150, behavior: 'smooth' });
            } else if (e.key === 'ArrowRight') {
                e.preventDefault();
                viewport.scrollBy({ left: isRTL ? -150 : 150, behavior: 'smooth' });
            }
        });
    }

    document.querySelectorAll('.category-slider').forEach(initSlider);
})();
